import { MenuItemType } from 'src/modules/designStudio/constants/hardCodedData/textureData';

const getRenderSelectorsForFilters = (
  selectedMenuItem: MenuItemType | undefined,
) => {
  let shouldRenderColorList = false;
  let shouldRenderTextureList = false;
  if (selectedMenuItem) {
    if (selectedMenuItem.thumbnail) {
      shouldRenderTextureList = true;
    } else {
      shouldRenderColorList = true;
    }
  }
  return { shouldRenderColorList, shouldRenderTextureList };
};

export { getRenderSelectorsForFilters };
